import React from 'react';
import { Alert } from 'antd';
import { ShoppingCartAlertsProps } from '../interfaces';

const ShoppingCartAlerts: React.FC<ShoppingCartAlertsProps> = ({
  error,
  firstCartIssueMessage,
}) => (
  <>
    {error && (
      <Alert
        className="cart-inline-error"
        message="Cart update failed"
        description={error}
        type="error"
        showIcon
      />
    )}
    {firstCartIssueMessage && (
      <Alert
        className="cart-inline-error"
        message="Cart needs attention"
        description={firstCartIssueMessage}
        type="warning"
        showIcon
      />
    )}
  </>
);

export default React.memo(ShoppingCartAlerts);
